import "./menu.css";
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBuildingColumns,
    faRightFromBracket,
    faShield,
    faUsers,
    faReceipt
} from '@fortawesome/free-solid-svg-icons';

//UTILS
import AdminService from "../../services/admin_services";

//VISUALS
import LOGO from '../../assets/images/full_dark.png';
import LOGO_BLACK from '../../assets/images/logo_black.png';
import TOKEN_BLACK from '../../assets/images/token_black.png';
import POLYGON from '../../assets/images/polygon-matic-logo.png';
import Button from "../button";

//TRANSLATION
import { useTranslation } from 'react-i18next';

const Menu = () => {
    const { t } = useTranslation();
    const [balances, setBalances] = useState("-");
    const [tokens, setTokens] = useState({});
    const [address, setAddress] = useState(null);
    const currentPath = window.location.pathname;

    const logout = () => {
        AdminService.logout()
    }

    const loadBalances = async() => {
        const data = await AdminService.getAdminBalance()
        setBalances(data.balances)
        let tokens = {}
        for (let token of data.balances.tokens) {
            tokens[token.metadata.symbol] = token
        }
        setTokens(tokens)
        setAddress(data.address)
    } 

    useEffect(() => {
        loadBalances();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <div className="left_menu">
                <img src={LOGO} alt="Lifise logo" className="logo" />
                <a href={"/admin/dashboard"} className={currentPath === "/admin/dashboard" ? "entry active mt-50" : "entry mt-50"}>
                    <span className="icon"><FontAwesomeIcon icon={faShield} /></span> {t('admin.admins')}
                </a>
                <a href={"/admin/users"} className={currentPath === "/admin/users" ? "entry active" : "entry"}>
                    <span className="icon"><FontAwesomeIcon icon={faUsers} /></span> {t('admin.users')}
                </a>
                <a href={"/admin/orders"} className={currentPath === "/admin/orders" ? "entry active" : "entry"}>
                    <span className="icon"><FontAwesomeIcon icon={faReceipt} /></span> {t('admin.orders')}
                </a>

                <div className="share">
                    <div className="rocket">
                        <FontAwesomeIcon icon={faBuildingColumns} />
                    </div>
                    <p className="center">
                        <small>{address}</small>
                        <br />
                        <big><strong>{t('admin.reserve_balance')}</strong></big>
                    </p>
                    {balances && tokens && <div className="admin_balances">
                        <div className="balance_row">
                            <span className="balance_token">CaaEURO</span>
                            <div className="balance_value_wrap">
                                <span className="balance_value">{tokens["CaaEURO"] && tokens["CaaEURO"].balance.toLocaleString()}</span>
                                <img src={LOGO_BLACK} width={"20px"} alt="Logo black"/>
                            </div>
                        </div>
                        <div className="balance_row">
                            <span className="balance_token">CAAM</span>
                            <div className="balance_value_wrap">
                                <span className="balance_value">{tokens["CAAM"] && tokens["CAAM"].balance.toLocaleString()}</span>
                                <img src={TOKEN_BLACK} width={"20px"} alt="Logo black"/>
                            </div>
                        </div>
                        <div className="balance_row compact">
                            <span className="balance_token">MATIC</span>
                            <div className="balance_value_wrap">
                                <span className="balance_value">{balances.matic && parseFloat(balances.matic).toFixed(2)}</span>
                                <img src={POLYGON} width={"14px"} alt="Logo Matic Polygon"/>
                            </div>
                        </div>
                    </div>}
                    <Button title={t('admin.disconnect')} click={logout}/>
                </div>
            </div>
            <div className="mobile_menu">
                <div className={currentPath === "/admin/dashboard" ? "entry realigned active" : "entry realigned"} onClick={() => window.location.href = "/admin/dashboard"}>
                    <FontAwesomeIcon icon={faShield} />
                </div>
                <div className={currentPath === "/admin/users" ? "entry realigned active" : "entry realigned"} onClick={() => window.location.href = "/admin/users"}>
                    <FontAwesomeIcon icon={faUsers} />
                </div>
                <div className={currentPath === "/admin/orders" ? "entry realigned active" : "entry realigned"} onClick={() => window.location.href = "/admin/orders"}>
                    <FontAwesomeIcon icon={faReceipt} />
                </div>
                <div className={"entry realigned"} onClick={logout}>
                    <FontAwesomeIcon icon={faRightFromBracket} />
                </div>
            </div>
        </>
    )
};

export default Menu;